import { format } from "date-fns";

/**
 * date string中の-を/に変換する
 * @param date YYYY-MM-DDまたはYYYY-M-D
 */
export const formatDate = (date: string): string => {
  return format(date, "YYYY/MM/DD");
};
